export default __webpack_public_path__ + "static/media/imgLanding.d63b408c.png";